'use client';


import React, { ReactNode } from 'react';
import { COLOR_ALPHA_NEUTRAL_900_ALPHA_12 } from '@/lib/variables';

interface ModalContainerProps {
	children: ReactNode;
	backgroundColor?: string
}


const ModalContainer: React.FC<ModalContainerProps> = ({
	children,
	backgroundColor = COLOR_ALPHA_NEUTRAL_900_ALPHA_12,
}) => {


	return (
		<div
			className="w-full h-full inline-flex items-center justify-center backdrop-blur-[10px]"
			style={{
				backgroundColor,
			}}
		>
			{children}
		</div>
	);
};

export default ModalContainer;
